
export class PaginatedCbI {
  public pageSize!: number;
  public page!: number;
  public textSearch? : string;
}
